import styled from '@emotion/styled';
import { BaseButton } from '../base';

export const UndoneButton = styled(BaseButton)`
    width: 40px;
    height: 40px;
    min-width: 0;
    padding: 0;
    border-radius: 50%;
    background-color: inherit;
    display: flex;
    align-items: center;
    justify-content: center;
`;
